import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

const StyledContentLayoutWrapper = styled.div`
  &.has-padding {
    padding: 24px;
    /* &.boxed-layout {
      padding: 24px 0;
    } */
  }
  &.top-padding {
    padding-top: 24px;
  }
  &.boxed-layout {
    max-width: ${props => props.theme.contentMaxWidth}px;
    margin: 0 auto;
  }
  &.large-content,
  &.large-content.boxed-layout {
    max-width: 1480px;
    margin: 0 auto;
  }
`;

export interface ContentLayoutWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {
  boxed?: boolean;
  padded?: boolean;
  // fix per aggiungere il padding in testa alla pagina
  // dopo l'inserimento dell'affix header
  topPadding?: boolean;
  /** per avere un content più esteso */
  largeContent?: boolean;
}

/**
 * Wrapper del Layout che definisce la larghezza massima del contenuto.
 */
export function ContentLayoutWrapper(props: ContentLayoutWrapperProps) {
  const { boxed, className, padded, topPadding, largeContent, ...divProps } =
    props;
  return (
    <StyledContentLayoutWrapper
      className={clx(className, {
        'boxed-layout': boxed,
        'has-padding': padded,
        'top-padding': topPadding,
        'large-content': largeContent,
      })}
      {...divProps}
    >
      {props.children}
    </StyledContentLayoutWrapper>
  );
}
